module.exports = __webpack_public_path__ + "img/fuel-level.54ec2fd1.svg";